export default {
  headerContent: {
    title: 'Mapfre Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Nakliyat (Emtea) Sigortası Nedir?',
    description: {
      title: 'Mapfre Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Nakliyat sigortası, bir yükün bir yerden bir yere taşınması esnasında meydana gelebilecek risklere karşı koruma sağlamaktadır. Mapfre Sigorta nakliyat sigortası ile sağlamış olduğu koruma ile kişilerin veya kurumların nakliyelerini koruma altına alarak sermayelerine güvence sağlamaktadır.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Nakliyat Sigortası Türleri Nedir?',
      content: [
        {
          paragraph: null,
          subList: [
            'Nakliyat sigortasında düzenlenmekte olan 4 adet poliçe çeşidi bulunmaktadır.',
            'Kati Poliçe',
            'Flotan Poliçe(Geçici)',
            'Abonman Poliçe',
            'Blok Poliçe'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
